import {IS_WEB} from '../utils/platform';
import {SUPABASE_AUTH_REDIRECT_URL} from './env';

/** Must match Android intent `biblijasp` host and Supabase redirect allow list. */
export const AUTH_NATIVE_REDIRECT_URL = 'biblijasp://auth';

/** Production password-reset landing (path `/auth`). Allowlist in Supabase Auth redirect URLs. */
export const PRODUCTION_WEB_APP_URL = 'https://biblija.live/auth';

/**
 * Parse Supabase implicit-callback parameters from hash and query (same rules as @supabase/auth-js).
 */
export function parseAuthParametersFromUrl(href) {
  const result = {};
  try {
    const url = new URL(href);
    if (url.hash?.[0] === '#') {
      try {
        const hashSearchParams = new URLSearchParams(url.hash.substring(1));
        hashSearchParams.forEach((value, key) => {
          result[key] = value;
        });
      } catch {
        // ignore malformed hash
      }
    }
    url.searchParams.forEach((value, key) => {
      result[key] = value;
    });
  } catch {
    return result;
  }
  return result;
}

/**
 * Target for password-reset emails (`redirect_to`). Web defaults to current origin; native uses deep link.
 */
export function getPasswordResetRedirectUrl() {
  const fromEnv =
    typeof SUPABASE_AUTH_REDIRECT_URL === 'string'
      ? SUPABASE_AUTH_REDIRECT_URL.trim()
      : '';
  if (fromEnv) {
    return fromEnv;
  }
  if (
    IS_WEB &&
    typeof globalThis !== 'undefined' &&
    globalThis.location?.origin
  ) {
    // Open the Auth screen (React Navigation `Auth` → `/auth`); hash tokens append after path.
    return `${globalThis.location.origin}/auth`;
  }
  if (!IS_WEB) {
    return AUTH_NATIVE_REDIRECT_URL;
  }
  return undefined;
}
